import { Injectable } from '@angular/core';
import { CanDeactivate, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { ConfirmationDialogComponent, ConfirmationDialogData } from '../shared/components/confirmation-dialog/confirmation-dialog.component';
import { CanDeactivateComponent } from './can-deactivate.interface';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class CanDeactivateGuard implements CanDeactivate<CanDeactivateComponent> {

  constructor(private dialog: MatDialog, private authService: AuthService, private router: Router) {}

  canDeactivate(component: CanDeactivateComponent): boolean | Observable<boolean> {
    const targetUrl = this.router.url;
    
    console.log(targetUrl)

    if (targetUrl === '/registration' || targetUrl === '/registration/prescription') {
      return true;
    }
    
    return component.canDeactivate() || this.showConfirmationDialog();
  }

  private showConfirmationDialog(): Observable<boolean> {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        dialogTitle: '',
        showDialogTitle: false,
        dialogMessage: 'All changes made will not be saved. Do you want to continue?',
        positiveButtonLabel: 'OK',
        negativeButtonLabel: 'Cancel',
        showPositiveButton: true,
        showNegativeButton: true,
        showCloseButton: false
      } as ConfirmationDialogData,
      width: '600px',
      panelClass: 'paacap-dialog'
    });

    return dialogRef.afterClosed().pipe(
      tap(result => {
        if (result) {
          this.authService.logout();
        }
      })
    );
  }
}